import { render, staticRenderFns } from "./BlackListSearch.vue?vue&type=template&id=63320a7f&scoped=true&"
import script from "./BlackListSearch.vue?vue&type=script&lang=js&"
export * from "./BlackListSearch.vue?vue&type=script&lang=js&"
import style0 from "./BlackListSearch.vue?vue&type=style&index=0&id=63320a7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63320a7f",
  null
  
)

export default component.exports